<iframe #frame [src]="safeSrc" class="lpw-frame" [class.open]="isOpen" (load)="onLoad()"></iframe>